import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import { Col, Card, Button } from "react-bootstrap";

//
import {
  changePlanModalStep,
  choosePlan,
} from "../../../../redux/features/plan/slice";

//
import Ribbon from "../../../general/Ribbon";

function PlanItems({ item, changePlanModalStep, choosePlan }) {
  const [limit, setLimit] = useState(2);

  /**
   * Choose a plan and change plan content modal for show choose payment methods
   */
  const setChoosedPlan = () => {
    choosePlan(item);
    changePlanModalStep("invoice");
  };

  return (
    <Col xs={12} md={6} xl={4} className="overflow-hidden">
      <Card className="item bordered">
        {item.isBest && (
          <Ribbon
            variant="warning"
            size="thine"
            content="Best Plan 🔥 . Best Plan 🔥 . Best Plan 🔥"
          />
        )}
        <Card.Body>
          <div className="name">
            <h5>{item.name}</h5>
            <img src={item.image} alt="plan icon" />
          </div>

          <div className="price">
            {+item.price_usd ? (
              <>
                <h3 className="fw-bolder">${item.price_usd}</h3>
                {!!item.price_point && (
                  <span className="text-warning">
                    or {item.price_point} Points
                  </span>
                )}
              </>
            ) : (
              <h3 className="fw-bolder">Free</h3>
            )}
          </div>

          <p className="decription">{item.description}</p>

          <div className="permissions">
            {Object.keys(item.features)
              .slice(0, limit)
              .map((keyName, i) => (
                <p key={i}>
                  <i
                    className={`las la-${
                      item.features[keyName].active
                        ? "check success"
                        : "times danger"
                    }`}
                  ></i>
                  <span>{item.features[keyName].title}</span>
                </p>
              ))}
          </div>

          {limit !== Object.keys(item.features).length && (
            <p
              className="text-info learn-more"
              onClick={() => setLimit(Object.keys(item.features).length)}
            >
              Learn more
            </p>
          )}

          <Button variant="info" size="lg" onClick={() => setChoosedPlan()}>
            Upgrade Plan
          </Button>
        </Card.Body>
      </Card>
    </Col>
  );
}

const mapDispatchToProps = {
  changePlanModalStep,
  choosePlan,
};

PlanItems.propTypes = {
  item: PropTypes.object.isRequired,
  changePlanModalStep: PropTypes.func.isRequired,
  choosePlan: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(PlanItems);
